import type { ShortcutConfig } from '@ztechapps/webui.util'
import type { ListField } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { DataTool } from '@ztechapps/webui.data-tools'
import { useKeyboardShortcut } from '@ztechapps/webui.util'
import { blogStatuses } from '../BlogStatusOptions'
import { useBlogListFieldConfig } from './useBlogListFieldConfig'
import { AddForm } from './addNew/AddForm'
import { BlogViewToggle } from './BlogViewToggle'
import { useBlogListContext } from './Context'

const getFields = (category: ListField) => [
  { name: 'title', displayName: 'Title' },
  { name: 'slug', displayName: 'Slug' },
  { name: 'summary', displayName: 'Summary' },
  {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: blogStatuses,
    },
  },
  category,
  { name: 'updatedAt', displayName: 'Date Updated', excludeOnSearch: true, type: ListFieldTypeEnum.dateTimeZone },
  { name: 'remarks', displayName: 'Remarks' },
  { name: 'tags', displayName: 'Tags' },
  { name: '_id', displayName: 'Id', excludeOnSort: true },
]

export type ToolboxProps = {
  refreshShortcut: ShortcutConfig
}

export const Toolbox = ({ refreshShortcut }: ToolboxProps) => {
  const context = useBlogListContext()
  const { category } = useBlogListFieldConfig()

  useKeyboardShortcut({ ...refreshShortcut, action: () => context.refetch?.() })

  return (
    <DataTool
      components={{
        add: AddForm,
        other: BlogViewToggle,
      }}
      onAdd={async () => {
        // Handled by AddForm component
      }}
      {...{
        searchPlaceHolder: 'Search Blogs',
        fields: getFields(category),
        ...context,
        // The DataTool prop of this name is the key its Filter menu loads saved filter templates under.
        filterCategory: context.filterStorageKey,
      }}
    />
  )
}
